/* eslint-disable no-unreachable */
import React, { useState } from "react";
import i18n from "i18n";
import { Tooltip } from "@material-ui/core";
import GetChannelImage from "helpers/GetChannelImage";
import DropMenu from "components/Menu/DropMenu";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getMesssageItemSelector } from "redux/selectors/cockpitSelectors";
import cockpitActions from "redux/actions/cockpitActions";
import engageActions from "redux/actions/engageActions";
import lod_ from "lodash";
import { errorMsg } from "redux/reducers/snackMsgsReducers";

/**
 * Get the correct mimeTypes for an attachment
 */
export const mimeTypeCompute = attachment => {
	let mimeType = "";

	if (attachment.mimeType) {
		mimeType = attachment.mimeType;
	}

	if (attachment.contentType) {
		mimeType = attachment.contentType;
	}

	if (mimeType === "") {
		if (attachment?.type === undefined) {
			mimeType = "application/pdf";
		} else if (attachment?.type?.indexOf("/") !== -1) {
			mimeType = attachment.type;
		} else {
			let fname = name?.toLowerCase();
			if (fname?.indexOf(".jpg") !== -1 || fname?.indexOf(".jpeg") !== -1) {
				mimeType = "image/jpeg";
			} else if (fname?.indexOf(".png") !== -1) {
				mimeType = "image/png";
			} else mimeType = "application/pdf";
		}
	}

	return mimeType;
};
/**
 * Get the file extension from a file name
 */
export const getFileExtension = fileName => {
	if (fileName) {
		const splited = fileName.split(".");
		if (splited.length > 1) {
			const ext = splited[splited.length - 1];
			return `.${ext.toUpperCase()}`;
		} else {
			return "";
		}
	} else {
		return "";
	}
};
/**
 * Get the file type from a mime type
 */
export const getFileType = mimeType => {
	if (mimeType) {
		let type = mimeType.split("/")[0];
		if (type !== "audio" && type !== "video" && type !== "image") {
			return "document";
		} else {
			return type;
		}
	} else {
		return "document";
	}
};
/**
 * Format bytes to a readable format
 */
export const formatBytes = (a, b = 2) => {
	if (0 === a) return "0 Bytes";
	const c = 0 > b ? 0 : b;
	const d = Math.floor(Math.log(a) / Math.log(1024));
	return (
		parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
		" " +
		["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
	);
};
/**
 * Manage file actions
 */
const FileActions = ({
	customDownloadProcess,
	attachment,
	customOpen = null,
	mID,
	availableActions = null // We can limit the actions available for a specific file, Example : ["viewFile", "downloadFile"]
}) => {
	const dispatch = useDispatch();
	const { actions } = useSelector(state => state.assistantconfig);
	const { selectedAssistantID, userStatus } = useSelector(state => state);
	const { selectedConversation } = useSelector(state => state.cockpit);
	const { channels } = useSelector(getMesssageItemSelector, shallowEqual);
	/**
	 * All availables actions
	 */
	const [filesActions, setFilesActions] = useState(
		/**
		 * Get all actions type "file" for attachments
		 */
		(actions ?? [])
			.filter(action => {
				if (lod_.isNil(availableActions)) {
					return true;
				} else if (lod_.isArray(availableActions)) {
					return availableActions.includes(action.code);
				} else {
					return false;
				}
			})
			.filter(action => action.scope === "file" && action.active === true)
			.sort((a, b) => {
				const rankA = a.rank ?? Infinity;
				const rankB = b.rank ?? Infinity;
				return rankA - rankB;
			})
			.map(action => {
				let tempObject = {};
				let possibleChannelToEngage = (lod_.isArray(channels) ? channels : []).filter(
					a => a.engage === true && a.type === "ML"
				);
				possibleChannelToEngage = possibleChannelToEngage.filter(a => {
					if (a.engage === true && (lod_.isNil(a?.engageFilter) || lod_.isEmpty(a?.engageFilter))) {
						return a;
					} else if (
						a.engage === true &&
						(!lod_.isNil(a?.engageFilter) || !lod_.isEmpty(a?.engageFilter))
					) {
						const keysPath = Object.keys(a.engageFilter);
						const path = keysPath[0];
						const value = a?.engageFilter[path];
						const valueContext = lod_.get(selectedConversation, path);
						if (!lod_.isNil(value) && !lod_.isNil(valueContext)) {
							if (
								lod_.isString(value) &&
								lod_.isString(valueContext) &&
								value.toLocaleLowerCase() === valueContext.toLocaleLowerCase()
							) {
								return a;
							} else if (value === valueContext) {
								return a;
							}
						}
					}
				});
				switch (action.code) {
					case "forwardAttachment":
						tempObject = {
							...action,
							subMenu: {
								items: possibleChannelToEngage.map((channel, index) => {
									return {
										name: (
											<Tooltip title={channel.name}>
												<img
													src={GetChannelImage(possibleChannelToEngage, channel.code)}
													alt="Channel-logo"
													width="20"
													height="20"
													className="logo-channel"
												/>
											</Tooltip>
										),
										code: action.code,
										config: action?.config || {},
										channel: channel || {},
										type: "fileGestion",
										subType: "forward",
										version: "2.0"
									};
								})
							}
						};

						break;
					default:
						tempObject = action;
						break;
				}

				/**
				 * Gestion of name with new format action front v2
				 * Get language of profile to get correct action name or default to english or first available
				 */
				const language = userStatus?.auth?.user?.language?.toUpperCase();
				let nameOfAction = action.name;
				if (!lod_.isNil(action.actionName) && !lod_.isEmpty(action.actionName)) {
					if (!lod_.isNil(language) && !lod_.isNil(action.actionName[language])) {
						nameOfAction = action.actionName[language];
					} else {
						nameOfAction =
							action.actionName.EN ?? Object.values(action.actionName)[0] ?? action.name;
					}
				}

				tempObject.name = nameOfAction;

				return tempObject;
			}) ?? []
	);
	/**
	 * Display picture in new window when user click on view button
	 */
	const handleDisplayPicture = attachment => {
		let { name = "Fichier / File : ", mimeType, url } = attachment;

		mimeType = ` type='${mimeType}'`;

		const ext = (name || url || "").split(".").pop().toLowerCase();
		const isVideo =
			["mp4", "mov", "webm", "ogg"].includes(ext) || (mimeType && mimeType.startsWith("video/"));

		const css = `<html><head><title>${name}</title>`;
		let img =
			'<object style="width:100%;height:100%;margin:0 auto;" data="' + url + '"' + mimeType + "/>";
		let body = '<body style="width:100%;height:100%;margin:0 auto;">';
		let header = null;

		const officeMimeTypes = [
			"application/msword",
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
			"application/vnd.ms-excel",
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			"application/vnd.ms-powerpoint",
			"application/vnd.openxmlformats-officedocument.presentationml.presentation"
		];

		if (mimeType.indexOf("pdf") === -1) {
			body =
				'<body style="margin: 0;transform: translate(-50%, -50%);left: 50%;top: 50%;position: absolute;">';
			img =
				'<object style="max-width:100vw;max-height:100vh;margin:0 auto;" data="' +
				url +
				'"' +
				mimeType +
				"/>";
		}

		if (!lod_.isNil(attachment?.mimeType) && officeMimeTypes.includes(attachment?.mimeType)) {
			header =
				" <style>  iframe { width: 100%; height: 100vh; border: none; } body {  margin: 0; } </style></head>";
			body =
				"<body> <iframe src=https://view.officeapps.live.com/op/embed.aspx?src=" +
				url +
				"></iframe>";
			img = null;
		}
		if (isVideo) {
			header = `<style>body{margin:0;padding:0;background:#000;} video{display:block;margin:auto;max-width:100vw;max-height:100vh;} object{width:100vw;height:100vh;} iframe{width:100vw;height:100vh;border:none;}</style>`;

			// Affichage vidéo plein écran avec contrôles
			body = `<body><video src='${url}' controls autoplay style='background:#000;'></video></body>`;
			img = null;
		}

		const popup = window.open("");
		popup.document.write(css);
		if (!lod_.isNil(header)) {
			popup.document.write(header);
		}
		popup.document.write(body);
		if (!lod_.isNil(img)) {
			popup.document.write(img);
		}
		popup.document.write("</body></html>");
		popup.document.close();
	};
	/**
	 * Download file (create fake download button)
	 */
	const handleDownload = async attachment => {
		let { name, url } = attachment;
		try {
			const image = await fetch(url);
			const imageBlog = await image.blob();
			const imageURL = URL.createObjectURL(imageBlog);

			const anchor = document.createElement("a");
			anchor.href = imageURL;
			anchor.download = name;

			document.body.appendChild(anchor);
			anchor.click();
		} catch (error) {
			dispatch(errorMsg(i18n.t("api.cannotDownloadFile")));
		}
	};
	/**
	 * Analyze attachment
	 */
	const handleAnalyzeAttachment = (attachment, actionType) => {
		let { url, name } = attachment;
		let analyzeImageObject = {
			action: actionType,
			code: actionType,
			payload: {
				assistantID: selectedAssistantID,
				mID: mID,
				fID: selectedConversation.header.fID,
				agentuID: userStatus.auth.user._id,
				params: {
					url: url,
					name: name
				}
			}
		};

		dispatch(cockpitActions.callFileAction(analyzeImageObject));
	};

	/**
	 * Forward attachment
	 */
	const handleFowardAttachment = (data, attachment) => {
		let initialDraft = {
			attachments: [attachment]
		};
		if (!lod_.isNil(data?.config) && !lod_.isEmpty(data?.config)) {
			initialDraft.forwardConfig = data.config;
		}
		dispatch(
			engageActions.createEngageConversation(
				data?.channel?.code,
				initialDraft,
				selectedConversation.header.fID
			)
		);
	};
	/**
	 * Handle action when user click on action in DropMenu
	 */
	const handleFileToCaseMessage = (data, attachment) => {
		let fileToCaseMessage = {
			action: "fileToCase",
			code: "fileToCase",
			payload: {
				assistantID: selectedAssistantID,
				mID: mID,
				fID: selectedConversation.header.fID,
				agentuID: userStatus.auth.user._id,
				params: {
					attachmentName: attachment.name
				}
			}
		};

		dispatch(cockpitActions.callMessageAction(fileToCaseMessage));
	};

	/**
	 * Analyze attachment for lg warranty spare part request
	 */
	const handleAnalyseLgWarrantySparePartRequest = attachment => {
		let { url, name } = attachment;
		let action = {
			action: "analyseLgWarrantySparePartRequest",
			code: "analyseLgWarrantySparePartRequest",
			payload: {
				assistantID: selectedAssistantID,
				mID: mID,
				fID: selectedConversation.header.fID,
				agentuID: userStatus.auth.user._id,
				params: {
					url: url,
					name: name
				}
			}
		};

		dispatch(cockpitActions.callFileAction(action));
	};

	/**
	 * Analyse document LLM
	 * @param {*} data
	 * @param {*} attachment
	 */
	const analyseDocumentLlm = (data, attachment) => {
		dispatch(
			cockpitActions.launchActionFrontV2("analyseDocumentLlm", {
				header: {
					assistantID: selectedConversation.header.assistantID,
					fID: selectedConversation.header.fID
				},
				payload: {
					analyseDocumentLlmCode: data.config.code,
					attachments: [attachment]
				}
			})
		);
	};

	/**
	 * Analyse document LLM to call analyseUnderstand for NYO
	 * @param {*} data
	 * @param {*} attachment
	 */
	const analyseUnderstand = (data, attachment) => {
		dispatch(
			cockpitActions.launchActionFrontV2("analyseUnderstand", {
				header: {
					assistantID: selectedConversation.header.assistantID,
					fID: selectedConversation.header.fID
				},
				payload: {
					codeAction: data.code,
					attachmentURL: attachment.url
				}
			})
		);
	};

	/**
	 * Handle action when user click on action in DropMenu
	 */
	const handleFileToClipboard = attachment => {
		let copyLocal = JSON.parse(localStorage.getItem("presse-papier")) || [];

		copyLocal.push({
			fID: selectedConversation.header.fID,
			name: attachment?.name,
			url: attachment?.url,
			assistantID: selectedAssistantID,
			type: "image"
		});

		localStorage.setItem("presse-papier", JSON.stringify(copyLocal));
		dispatch(cockpitActions.setCopyClipboard());
	};

	/**
	 * Handle action when user click on action in DropMenu
	 */
	const handleProcessFileGestion = (data, attachment) => {
		switch (data.subType) {
			case "view":
				handleDisplayPicture(attachment);
				break;
			case "download":
				if (!customDownloadProcess) {
					/**
					 * Classic download
					 */
					handleDownload(attachment);
				} else {
					/**
					 * Special case for Cold to transform url to signed url
					 */
					customDownloadProcess(attachment.url);
				}
				break;
			case "forward":
				handleFowardAttachment(data, attachment);
				break;
			case "copy":
				handleFileToClipboard(attachment);
				break;
			default:
				break;
		}
	};

	const handleDropMenuActions = (data, attachment) => {
		if (data.version === "2.0") {
			switch (data.type) {
				case "analyseUnderstand":
					analyseUnderstand(data, attachment);
					break;
				case "fileGestion":
					handleProcessFileGestion(data, attachment);
					break;
				default:
					break;
			}
		} else {
			switch (data.code) {
				case "viewFile":
					handleDisplayPicture(attachment);
					break;
				case "downloadFile":
					if (!customDownloadProcess) {
						/**
						 * Classic download
						 */
						handleDownload(attachment);
					} else {
						/**
						 * Special case for Cold to transform url to signed url
						 */
						customDownloadProcess(attachment.url);
					}
					break;
				case "analyzeWaterMeter":
					handleAnalyzeAttachment(attachment, "analyzeWaterMeter");
					break;
				case "analyzeHeatPump":
					handleAnalyzeAttachment(attachment, "analyzeHeatPump");
					break;
				case "fowardAttachment":
					handleFowardAttachment(data, attachment);
					break;
				case "fileToCase":
					handleFileToCaseMessage(data, attachment);
					break;
				case "copyFile":
					handleFileToClipboard(attachment);
					break;
				case "analyseLgWarrantySparePartRequest":
					handleAnalyseLgWarrantySparePartRequest(attachment);
					break;
				case "analyseDocumentLlm":
					analyseDocumentLlm(data, attachment);
					break;
				default:
					if (!lod_.isNil(data?.type)) {
						switch (data.type) {
							case "analyseUnderstand":
								analyseUnderstand(data, attachment);
								break;
						}
					}
					break;
			}
		}
	};
	return (
		<DropMenu
			handleAction={data => {
				handleDropMenuActions(data, attachment);
			}}
			items={filesActions}
			customOpen={customOpen}
		/>
	);
};

export default FileActions;
